<template>
  <modal class="batchlist-modal vs-space-table" title="批号列表">
    <div class="top w-full bg-transparent">
      <vs-button class="mr-3 mb-2" @click="addBatchNo(product)">
        新建批号
      </vs-button>
    </div>
    <vs-table :data="product.batchNo" class="w-full xxl:w-1/2 " noDataText="暂无数据">
      <template slot="thead">
        <vs-th>批号</vs-th>
        <vs-th>操作</vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :data="b" :key="i" v-for="(b, i) in data">
          <vs-td><span class="text-primary cursor-pointer" @click="$router.push('/batchno/detail/' + b.id)">{{b.batchNo}}</span></vs-td>
          <vs-td>
            <span class="text-primary cursor-pointer" @click="editBatchNo(b, product)" v-if="$acl.check('batch_edit')">修改批号</span>
            <span class="text-primary cursor-pointer ml-5" @click="previewBatch(b)">预览溯源</span>
            <span class="text-primary cursor-pointer ml-5" @click="toEdit(b)">{{$acl.check('batch_edit') ? '编辑溯源' : '查看溯源'}}</span>
            <a @click.stop="willRemoveBatch(b, product, i)" class="ml-5 text-danger" v-if="$acl.check('batch_edit')">删除</a>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </modal>
</template>

<script>
  export default {
    name: "batchList",
    props: {
      product: Object
    },
    methods: {
      willRemoveBatch(batch, product, index) {
        this.$confirm({
          color: 'danger',
          title: '确定删除该商品批号？',
          text: '删除后该批号后，对应的溯源内容将一并删除，并且不可恢复。<br /><br />如果该批号未下单，您可以删除该批号，否则将删除失败。',
          accept: async () => {
            await this.$s.product.batchNoRemove(batch.id).then(() => {
              this.$notify({
                title: '删除成功',
              })
              product.batchNo.splice(index, 1)
            }).catch(err => {
              if (err.status == 100103) {
                this.$notify({
                  color: 'danger',
                  title: '删除失败，请确认该批号是否可删除',
                })

              }
            })

          }
        })
      },
      toEdit(b){
        this.$router.push('/batchno/detail/' + b.id)
        this.$modalClose()
      },
      addBatchNo(item) {
        this.$modal('editBatchNo', {
          product: item,
          onOk(data) {
            item.batchNo.push(data)
          }
        })
      },
      editBatchNo(batch, product) {
        this.$modal('editBatchNo', {
          batch: batch,
          product: product,
          onOk(data) {
            batch.batchNo = data.batchNo
          }
        })
      },
      previewBatch(b) {
        this.$modal('previewTraceQr', {batchID: b.id})
      }
    }
  }
</script>

<style lang="scss">
  .batchlist-modal {
  .vs-dialog {
    max-width: 100%;
    width: 500px;
  }
  }
</style>